import { AbstractControl, FormGroup } from '@angular/forms';
import { ValidationService } from './validation.service';

function setControlValidators(
  form: FormGroup,
  validationService: ValidationService,
  formFieldName: string,
  required: boolean
) {
  const control: AbstractControl = form.controls[formFieldName];

  if (!control) {
    console.warn(`Control with name ${formFieldName} not found.`);
    return;
  }

  if (required) {
    control.setValidators(validationService.getValidatorsAndRequired(formFieldName));
  } else {
    control.setValidators(validationService.getValidators(formFieldName));
  }

  control.updateValueAndValidity({ emitEvent: true });
}

// Method is going to make the fields, of the provided art type, required. At the same type, is going to make all the other fields, for all the other arts, unrequired.
// Art is depended on the requiredFieldsArray. It should have the value of index + 1. From a business perspective, requiredFieldsArray holds the requiredFields for all the arts.
// Example: lets consider that for "person", art should be 1. The method expects for this case, that on the index = 0, in the requiredFieldsArray, to be the required fields for the art "person".
export function makeValidatorChanges(form: FormGroup, validationService: ValidationService,
                                     art: string, requiredFieldsArray: Array<string[]>) {
  if (form && validationService && art && requiredFieldsArray) {
    const index = Number(art) - 1;
    const requiredFieldsToSet = requiredFieldsArray[index];
    const requiredFieldsToUnset = [];
    requiredFieldsArray.forEach((value, _index) => {
      if (_index !== index) {
        requiredFieldsToUnset.push(...value);
      }
    });

    makeFieldsRequiredOrNotRequired(form, validationService, false, requiredFieldsToUnset);
    makeFieldsRequiredOrNotRequired(form, validationService, true, requiredFieldsToSet);
  }
}

export function makeFieldsRequiredOrNotRequired(
  form: FormGroup,
  validationService: ValidationService,
  required: boolean,
  fieldNames: string[]
) {

  required ? makeFieldsRequired(form, validationService, fieldNames) : makeFieldsNotRequired(form, validationService, fieldNames);
}

export function makeFieldsRequired(
  form: FormGroup,
  validationService: ValidationService,
  fieldNames: string[]
) {

  fieldNames.forEach(fieldName => {
    validationService.makeRequired(form.controls[fieldName]);
  });
}

export function makeFieldsNotRequired(
  form: FormGroup,
  validationService: ValidationService,
  fieldNames: string[]
) {

  fieldNames.forEach(fieldName => {
    validationService.makeNotRequired(form.controls[fieldName]);
  });
}

export function getControlNames(formGroup: FormGroup): Array<string> {
  if (formGroup) {
    return Object.keys(formGroup.controls);
  }
  return [];
}
